function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Path, {
  d: "M12.985 22.704h16.928a2.375 2.375 0 002.375-2.375V4.004a2.375 2.375 0 00-2.375-2.375H4.606a2.376 2.376 0 00-2.375 2.375v7.947",
  stroke: "#999",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement(Path, {
  fill: "#999",
  d: "M1.833 22.933a1.068 1.068 0 101.51-1.51 1.068 1.068 0 00-1.51 1.51"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#999",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M9.77 22.637a7.62 7.62 0 00-2.239-5.403 7.618 7.618 0 00-5.401-2.238m4.55 7.641c0-1.165-.444-2.33-1.333-3.219a4.542 4.542 0 00-3.22-1.333"
}));

function SvgIconMenuPlateformes(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 24
  }, props), _ref);
}

export default SvgIconMenuPlateformes;